<template lang="html">
  <div id="user-account-page">

    <section class="placed-backg banner-section" v-bind:style="{ backgroundImage: 'url('+$root.user.usercompany.imageUrlBanner+')' }">
      <div class="inside">
        <h1>{{$root.user.name}}</h1>
      </div>
    </section>



    <section class="main-section">
      <div class="container">
        <div class="row">

          <div class="col-lg-3 col-sidebar">
            <div class="content">

              <div class="box-column-title">Perfil usuario</div>

              <div class="box-user-info">
                <div class="box-image">
                  <div class="img" v-bind:style="{ backgroundImage: 'url('+$root.user.usercompany.imageUrl+')' }"></div>
                </div>

                <div class="box-info">
                  <p class="mb-2">
                    <router-link class="btn-squ-cur-1 outline-aqua" :to="{ name: 'userAccImagePhoto' }"><i class="poi"></i> Cambiar imagen</router-link>
                  </p>
                  <p class="mb-2">
                    <a class="btn-squ-cur-1 blue-s2 lg" @click="downloadcv()" >Descargar CV</a>
                  </p>


                  <h5>{{$root.user.usercompany.escolaridad}}</h5>
                  <h5>Sector: {{$root.user.usercompany.area}}</h5>
                  <h5 v-if="$root.user.usercompany.edad != null">Edad: {{$root.user.usercompany.edad}} Años</h5>

                  <p class="mt-4">
                    <router-link class="btn-squ-cur-1" :to="{ name: 'userAccBanner' }">Cambiar cabecera</router-link>
                  </p>
                </div>
              </div>

              <div class="box-account-options">
                <router-link class="btn-acc btn-op1" :to="{ name: 'userAccIndex' }"><span>Mi Panel</span></router-link>
                <router-link class="btn-acc btn-op9" :to="{ name: 'userAccBanner' }"><span>Imagen de cabecera</span></router-link>
                <router-link class="btn-acc btn-op2" :to="{ name: 'userAccProfile' }"><span>Editar Perfil</span></router-link>
                <router-link class="btn-acc btn-op3" :to="{ name: 'userAccCV' }"><span>Mi Curriculum</span></router-link>
                <router-link class="btn-acc btn-op4" :to="{ name: 'userAccAppliedVacancies' }"><span>Vacantes Aplicadas</span></router-link>
                <!-- <router-link class="btn-acc btn-op5" to="/"><span>Alertas Creadas</span></router-link> -->
                <router-link class="btn-acc btn-op6" :to="{ name: 'userAccComments' }"><span>Mi calificacion</span></router-link>
                <router-link class="btn-acc btn-op11" :to="{ name: 'userAccCommentstocompanies' }"><span>Calificaciones a empresas</span></router-link>
                <!-- <router-link class="btn-acc btn-op7" :to="{ name: 'userAccMessages' }"><span>Mensajes</span></router-link> -->

                <router-link class="btn-acc btn-op10" :to="{ name: 'userVacants' }"><span>Favoritos</span></router-link>
              <router-link class="btn-acc btn-op7" :to="{ name: 'userAccMessages' }"><span>Mensajes</span></router-link>
                <router-link class="btn-acc btn-op8" :to="{ name: 'userAccSecurity' }"><span>Seguridad</span></router-link>



                <button class="trans-250 btn-logout" @click="logout" >Salir</button>
              </div>

            </div>
          </div>

          <router-view></router-view>

        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{

    }
  },

  watch:{

  },
  methods:{

      logout(){
        axios.post(tools.url("/logout")).then((response)=>{
            this.$root.user = {};
            this.$root.logged=null;
            this.$root.type_logged='';
            this.$router.push('/');
          }).catch(()=>{});
      },
      downloadcv(){
          axios.get(tools.url("/downloadCvPostulate/"+this.$root.user.usercompany.id)).then((response)=>{
              console.log(response);
              window.open(response.data,'_blank');
          }).catch(()=>{});
      }


  },
  mounted() {
      this.$root.auth();
  },
}
</script>
